export default __webpack_public_path__ + "static/media/video-intro.85adb509.mp4";